import React, { useRef } from 'react';
import { Box, Input, Typography } from '@material-ui/core';
import { observer } from 'mobx-react';

import { useStores } from '../../hooks/use-stores';

import { loc } from '../../lib/loc';
import { ProfileLoc } from '../../loc/profile';

import PreloadButton from '../../interface/PreloadButton';

const EditContactData = observer(() => {
    const { ProfileDataStore: store } = useStores();
    const { email, fio } = store.profile || {};
    const { editLoader, editContactData } = store || {};

    const emailRef = useRef();
    const fioRef = useRef();

    const handle = e => {
        e.preventDefault();
        editContactData(emailRef.current.value, fioRef.current.value);
    };

    return (
        <form onSubmit={handle}>
            <Box display="flex" flexDirection="column">
                <Box mb={2}>
                    <Typography variant="h6">{loc(ProfileLoc.changeContact)}</Typography>
                </Box>
                <Input
                    inputRef={emailRef}
                    className="login-form__input"
                    placeholder={loc(ProfileLoc.newEmail)}
                    defaultValue={email}
                    type="text"
                    required
                />
                <Input
                    inputRef={fioRef}
                    className="login-form__input"
                    placeholder={loc(ProfileLoc.newFIO)}
                    defaultValue={fio}
                    type="text"
                    required
                />
                <Box>
                    <PreloadButton isLoad={editLoader}>{loc(ProfileLoc.changeButton)}</PreloadButton>
                </Box>
            </Box>
        </form>
    );
});

export default EditContactData;
